var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: !!_vm.activities, loading: _vm.loading } },
    [
      _c(
        "div",
        [
          _c("ClientsVisitsCollectionFilters", {
            attrs: {
              currentUserId: _vm.currentUser?.id,
              currentUserRole: _vm.currentUser?.role,
              filters: _vm.projectFilters,
              hideContractorsFilter: "",
              hideBudgetFilter: "",
            },
            on: {
              filtersChanged: _vm.updateFilters,
              filtersReset: _vm.resetFilters,
            },
          }),
          _c("p", { staticClass: "mb-6 text-sm font-normal" }, [
            _vm._v(" " + _vm._s(_vm.totalCount) + " Total accepted visits "),
          ]),
          _vm.empty
            ? _c("EmptyListPlaceholder", {
                attrs: { title: _vm.emptyListMessage },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageProjects")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4049957145
                ),
              })
            : _c(
                "div",
                { staticClass: "mb-4 flex flex-wrap gap-4" },
                _vm._l(_vm.activities, function (activity) {
                  return _c("ResourceAcceptedVisits", {
                    key: activity.id,
                    attrs: {
                      activity: activity,
                      project: activity.project,
                      client: _vm.getClientData(activity),
                      currentUserId: _vm.currentUserId,
                      projectDetailsRoute:
                        _vm.routeNames.CONTRACTOR_PROJECT_ACTIVITY,
                    },
                    on: {
                      updated: function ($event) {
                        return _vm.$apollo.queries.activities.refetch()
                      },
                    },
                  })
                }),
                1
              ),
        ],
        1
      ),
      _c("CardPagination", {
        attrs: { config: _vm.paginationConfig },
        on: {
          "update:config": function ($event) {
            _vm.paginationConfig = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }